import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Modal, Message, Loader, Dimmer,
} from 'semantic-ui-react';
import SaleInformationList from './saleInformationList';

class SaleInformationForm extends Component {
  render() {
    const {
      isModalOpen,
      onCloseHandler,
      error,
      eatTransactionId,
      vinHeader,
      externalAuctionTransactionsEventData,
      loading,
    } = this.props;
    const resultSaleInformation = () => {
      return (
        <div>
          {' '}
          {loading && (
            <Dimmer active inverted>
              <Loader size='large'> Loading </Loader>{' '}
            </Dimmer>
          )}{' '}
          <SaleInformationList
            eatTransactionId={eatTransactionId}
            externalAuctionTransactionsEventData={
              externalAuctionTransactionsEventData
            }
          />{' '}
        </div>
      );
    };

    return (
      <Modal
        open={isModalOpen}
        closeIcon
        onClose={onCloseHandler}
        closeOnEscape={false}
        closeOnRootNodeClick
        size='fullscreen'
      >
        <Modal.Header>Sale Information - {vinHeader}</Modal.Header>
        <Modal.Content image scrolling>
          <Modal.Description>
            {error && (
              <Message negative>
                <p>{error}</p>
              </Message>
            )}
            {resultSaleInformation()}
            <br />
            <br />
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions />
      </Modal>
    );
  }
}

SaleInformationForm.propTypes = {
  isModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func,
  error: PropTypes.string,
  eatTransactionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  vinHeader: PropTypes.string,
  externalAuctionTransactionsEventData: PropTypes.array,
  loading: PropTypes.bool,
};

SaleInformationForm.defaultProps = {
  isModalOpen: false,
  onCloseHandler: () => {},
  error: null,
  eatTransactionId: null,
  vinHeader: '',
  externalAuctionTransactionsEventData: [],
  loading: false,
};

export default SaleInformationForm;
